import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { firstLetterToUpperCase } from 'services/utils/string';

const StyledSelect = styled.select`
  height: 28px;
  width: 100%;
  border-radius: 3px;
  border: 1px solid lightgray;
  &:focus {
    background-color: ${({ theme }) => theme.blowPrimaryLight};
  }
`;

const ColorSampleType = ({ handleChange, value }) => {
  const order = useSelector((state) => state.newOrder);
  return (
    <StyledSelect
      name="type"
      value={value}
      onChange={handleChange}
      required
    >
      {order.samplesTypes.map((type, index) => (
        <option key={index} value={type}>
          {firstLetterToUpperCase(type)}
        </option>
      ))}
    </StyledSelect>
  );
};

export default ColorSampleType;
